"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OwsOptionsFeatureType_1 = require("./store/schema/OwsOptionsFeatureType");
exports.OwsOptionsFeatureType = OwsOptionsFeatureType_1.OwsOptionsFeatureType;
var owa_bundling_1 = require("owa-bundling");
var owa_delayed_initialization_1 = require("owa-delayed-initialization");
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "OutlookServiceOptions" */ './lazyIndex');
});
exports.lazyCreateOrUpdateOptionsForFeature = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.createOrUpdateOptionsForFeature; });
// Synchronous exports
var getOptionsForFeature_1 = require("./selectors/getOptionsForFeature");
exports.getOptionsForFeature = getOptionsForFeature_1.default;
// Load the options after bootstrap
// We may, in the future, move this to bootstrap and block boot on its resolution
//
// 'loadOptions' is intentionally not exported, as it should only be called by the following
// 'runAfterBootstrap' callback
var lazyLoadOptions = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.loadOptions; });
owa_delayed_initialization_1.runAfterBootstrap(function () {
    lazyLoadOptions.importAndExecute();
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-outlook-service-options/lib/index.js
// module id = 2110
// module chunks = 2 3 4 39 49 108